import React from "react";
import PropTypes from "prop-types";
import { SkedIcon } from "ui";
import { useSelector, useDispatch } from "react-redux";
import { toggleFeedMedia } from "actions/sourceMedia";
import { getSelectedFeedIds } from "selectors/hashtagFeedSelectors";
import { showViewHashtagFeedItemModal } from "actions/modal";
import "./FeedGrid.less";
import GridMediaCard from "components/MediaLibrary/GridMediaCard/GridMediaCard";
import moment from "moment";
import NumberFormat from "react-number-format";

const FeedGrid = ({ feedMedia }) => {
  const dispatch = useDispatch();
  const selectedFeedIds = useSelector(getSelectedFeedIds);

  const getHoverProps = (media) => {
    return (
      <div className="flex flex-col">
        <div className="flex pt-2 pl-2 pr-2 pb-1 h-full items-center cursor-default">
          <div className="flex flex-wrap">
            <div className="flex">
              <SkedIcon
                icon="icon-heart"
                size="14"
                className="cursor-default"
              />
              <span className="ml-1 mr-2 text-base leading-tight">
                <NumberFormat
                  value={media.like_count}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </span>
            </div>
            <div className="flex">
              <SkedIcon
                icon="icon-ig-comment"
                size="14"
                className="cursor-default"
              />
              <span className="ml-1 mr-2 text-base leading-tight">
                <NumberFormat
                  value={media.comments_count}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </span>
            </div>
          </div>
          <div className="flex-grow flex justify-end font-black">
            <div className="mr-2 leading-none">
              {media.permalink ? (
                <a
                  href={media.permalink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SkedIcon
                    icon="icon-crop-2"
                    color="purple"
                    size="14"
                    tooltip="View on Instagram"
                  />
                </a>
              ) : (
                <a
                  href={media.media_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SkedIcon
                    icon="icon-click"
                    color="purple"
                    size="14"
                    tooltip="View original file"
                  />
                </a>
              )}
            </div>
            <div className="leading-none">
              <SkedIcon
                icon="icon-eye"
                size="14"
                color="purple"
                className="cursor-pointer"
                tooltip="View post details"
                onClick={() => dispatch(showViewHashtagFeedItemModal(media))}
              />
            </div>
          </div>
        </div>
        {media.timestamp && (
          <div className="flex items-center text-sm pl-2">
            {moment(media.timestamp).fromNow()}
          </div>
        )}
      </div>
    );
  };
  const handleCardClick = (media) => {
    dispatch(toggleFeedMedia(media));
  };

  return (
    <div className="flex flex-wrap">
      {feedMedia.map((media) => {
        const isSelected = selectedFeedIds.includes(media.id);
        const isVideo = media.media_type === "VIDEO";

        if (!media.media_url) {
          return <></>;
        }

        return (
          <GridMediaCard
            key={media.id}
            id={media.id}
            assetUrl={media.thumbnail || media.media_url}
            selected={isSelected}
            selecting={selectedFeedIds.length > 0}
            hoverProps={getHoverProps(media)}
            canFavorite={false}
            onCardClick={() => handleCardClick(media)}
            isVideo={isVideo}
            videoPreviewUrl={media.thumbnail || media.media_url}
          />
        );
      })}
    </div>
  );
};

FeedGrid.propTypes = {
  feedMedia: PropTypes.array,
};

export default FeedGrid;
